<template>
    <v-img v-bind="{ src, style }" max-width="unset" @click="onClick">
        <slot />
    </v-img>
</template>

<script>
import { EMPLOYMENT_FIELD_TYPES, initEmploymentField } from "@/assets/variables";
import { mapGetters } from "vuex";
export default {
    props: {
        value: { type: Array, default: () => [] }, // form.fields
        page: { type: [Object, File], default: () => ({}) },
        pageIndex: { type: Number, default: 0 },
    },
    data: () => ({
        fields: [],
        page_prev: null,
        src: null,
    }),
    computed: {
        ...mapGetters("employment/form/page", ["width"]),
        ...mapGetters("employment/form/tool", { isToolOn: "isOn" }),
        style() {
            let { width } = this;
            width += "px";
            return { width };
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            if (this.page instanceof File) {
                if (this.page_prev != this.page) {
                    this.src = URL.createObjectURL(this.page);
                }
            } else this.src = this.page?.src;

            this.page_prev = this.page;
            this.fields = [...this.value];
        },
        emit() {
            this.$emit("input", this.fields);
        },
        onClick(/** @type {PointerEvent} */ event) {
            if (!this.isToolOn) return;

            event.preventDefault();
            event.stopPropagation();

            let { side, type } = this.$store.state.employment.form.tool;
            let { pageIndex: page } = this;

            let { width, height } = event.target.getBoundingClientRect();

            let axis = { x: event.offsetX / width, y: event.offsetY / height };

            let size = (() => {
                let charSize = 3;
                switch (type) {
                    case EMPLOYMENT_FIELD_TYPES.CBOX.value: {
                        return { w: charSize / 100, h: charSize / ((height / width) * 100) };
                    }
                    case EMPLOYMENT_FIELD_TYPES.DATE.value: {
                        return { w: (charSize * 4) / 100, h: charSize / ((height / width) * 100) };
                    }
                    case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                        return { w: (charSize * 3) / 100, h: (charSize * 3) / ((height / width) * 100) };
                    }
                    case EMPLOYMENT_FIELD_TYPES.TEXT.value: {
                        return { w: (charSize * 4) / 100, h: charSize / ((height / width) * 100) };
                    }
                }
            })();

            let field = initEmploymentField({ side, type, page, axis, size });
            this.fields.push(field);
            this.emit();

            this.$store.commit("employment/form/tool/init");
        },
    },
};
</script>

<style lang="scss" scoped>
.item-page {
    position: relative;
}
</style>
